import { render, staticRenderFns } from "./orderDetail-element.vue?vue&type=template&id=48b11896&scoped=true&"
import script from "./orderDetail-element.vue?vue&type=script&lang=js&"
export * from "./orderDetail-element.vue?vue&type=script&lang=js&"
import style0 from "./orderDetail-element.vue?vue&type=style&index=0&id=48b11896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b11896",
  null
  
)

export default component.exports